import { FormLabel, TextField as MuiTextField } from '@mui/material';
import React, { forwardRef } from 'react';

import styles from './textfield.module.scss';
import { TextFieldProps } from './types';

const TextField = forwardRef<HTMLInputElement, TextFieldProps>(({ label, ...props }, ref) => {
  return (
    <>
      <FormLabel sx={{ mb: 1, display: 'block' }}>{label}</FormLabel>
      <MuiTextField className={styles.textField} inputRef={ref} {...props} />
    </>
  );
});

TextField.displayName = 'TextField';

export default TextField;
